import { render, staticRenderFns } from "./ConfigDoc.vue?vue&type=template&id=53e6d592&scoped=true&"
import script from "./ConfigDoc.vue?vue&type=script&lang=js&"
export * from "./ConfigDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e6d592",
  null
  
)

export default component.exports